export const reports = {
	header: {
		title: "Relatórios de reserva",
		description: "Veja a performance de reservas no período selecionado",
		selectDate: "Selecione a data",
		filterBySalon: "Filtrar por salão",
	},
	salons: {
		all: "Todos os salões",
		main: "Salão Principal",
		vip: "Salão VIP",
	},
	metrics: {
		totalTables: "Total de mesas",
		totalPeople: "Total de pessoas",
	},
	charts: {
		generalFlow: {
			title: "Fluxo geral",
			tooltip: "Gráfico que mostra o fluxo de reservas ao longo do período selecionado",
		},
		statusPie: {
			title: "Reservas por status",
			tooltip:
				"Distribuição percentual das reservas por status (Acomodados, Cancelados, Não compareceram)",
		},
		weekDayFlow: {
			title: "Fluxo por dia de semana",
			bestDay: "é o seu melhor dia",
		},
		averagePeople: {
			title: "Média de pessoas por mesa",
			tooltip: "Média de pessoas por mesa em diferentes faixas",
		},
	},
};
